import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';

export const identificationOptions = [
  {
    label: <Translator file="module-communicationPipeline" name="anonymous" />,
    value: 0,
  },
  {
    label: <Translator file="module-communicationPipeline" name="identified" />,
    value: 1,
  },
];

export const companiesOptions = [
         { label: 'Haizea Bilbao', value: 0 },
         { label: 'Haizea Tecnoaranda', value: 1 },
         { label: 'Haizea Grupo WEC', value: 2 },
         { label: 'Haizea Breizh', value: 3 },
         { label: 'Haizea Sica', value: 4 },
         { label: 'Haizea Investments', value: 5 },
         { label: 'Haizea Wind Group Management', value: 6 },
         { label: 'Haizea Metal Structures', value: 7 },
         { label: 'Haizea Onshore', value: 8 },
         { label: 'Haizea International Investments', value: 9 },

         { label: 'Sociedad de Cartera Zestoa', value: 10 },
         { label: 'Haizea WEC Mecanizado', value: 11 },
         { label: 'Haizea WEC Fundición', value: 12 },
         { label: 'Haizea WEC Tratamiento Superficial', value: 13 },
         { label: 'WEC Business and Technology Center', value: 14 },
         { label: 'Conecta Logistics and Engineering', value: 15 },
       ];

export const relationOptions = [
  {
    label: <Translator file="module-communicationPipeline" name="bidder" />,
    value: 0,
  },
  {
    label: <Translator file="module-communicationPipeline" name="provider" />,
    value: 1,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="subcontractor" />
    ),
    value: 2,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="shareholder" />
    ),
    value: 3,
  },
  {
    label: <Translator file="module-communicationPipeline" name="employee" />,
    value: 4,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="former-employee" />
    ),
    value: 5,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="client" />
    ),
    value: 7,
  },
  {
    label: <Translator file="module-communicationPipeline" name="others" />,
    value: 6,
  },
];

export const keyserAndMackayRelationOptions = [
  {
    label: <Translator file="module-communicationPipeline" name="provider" />,
    value: 1,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="subcontractor" />
    ),
    value: 2,
  },
  {
    label: <Translator file="module-communicationPipeline" name="employee" />,
    value: 4,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="former-employee" />
    ),
    value: 5,
  },
  {
    label: <Translator file="module-communicationPipeline" name="client" />,
    value: 7,
  },
  {
    label: <Translator file="module-communicationPipeline" name="others" />,
    value: 6,
  },
];

export const relationWithGenreOptions = [
  {
    label: (
      <Translator file="module-communicationPipeline" name="bidder-bidder" />
    ),
    value: 0,
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="provider-provider"
      />
    ),
    value: 1,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="subcontractor" />
    ),
    value: 2,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="shareholder" />
    ),
    value: 3,
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="employee-employee"
      />
    ),
    value: 4,
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="former-employee-former-employee"
      />
    ),
    value: 5,
  },
  {
    label: <Translator file="module-communicationPipeline" name="others" />,
    value: 6,
  },
];

export const complaintOptions = [
  {
    label: <Translator file="module-communicationPipeline" name="corruption" />,
    value: 0,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="money-laundering" />
    ),
    value: 1,
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="books-accounting-records-irregularities-accounting-practices"
      />
    ),
    value: 2,
  },
  {
    label: <Translator file="module-communicationPipeline" name="theft" />,
    value: 3,
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="fraud-document-forgery-breach-trust"
      />
    ),
    value: 4,
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="unfair-competition-practices"
      />
    ),
    value: 5,
  },
  {
    label: <Translator file="module-communicationPipeline" name="harassment" />,
    value: 6,
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="confidential-business-information-industrial-secrets"
      />
    ),
    value: 7,
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="human-rights" />
    ),
    value: 8,
  },
  {
    label: <Translator file="module-communicationPipeline" name="others-2" />,
    value: 9,
  },
];

export const noYesOptions = [
  {
    label: <Translator file="module-comsaEnvironmental" name="no" />,
    value: 0,
  },
  {
    label: <Translator file="module-comsaEnvironmental" name="yes" />,
    value: 1,
  },
];

export const statusSteps = [
  {
    label: (
      <Translator file="module-communicationPipeline" name="complaint-sent" />
    ),
    value: 'sent',
    name: 'sent',
    description: (
      <Translator
        file="module-communicationPipeline"
        name="complaint-sent-user"
      />
    ),
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="registration" />
    ),
    value: 'sign',
    name: 'sign',
    description: (
      <Translator
        file="module-communicationPipeline"
        name="complaint-currently-being-registered"
      />
    ),
  },
  {
    label: <Translator file="module-communicationPipeline" name="in-process" />,
    value: 'processing',
    name: 'processing',
    description: (
      <Translator
        file="module-communicationPipeline"
        name="complaint-currently-in-process"
      />
    ),
  },
  {
    label: <Translator file="module-communicationPipeline" name="report" />,
    value: 'subjectToAppeal',
    name: 'subject-to-appeal',
    description: (
      <Translator
        file="module-communicationPipeline"
        name="complaint-subject-to-appeal"
      />
    ),
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="allegations" />
    ),
    value: 'allegations',
    name: 'allegations',
    description: (
      <Translator
        file="module-communicationPipeline"
        name="complaint-in-period-allegations"
      />
    ),
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="final-resolution" />
    ),
    value: 'end',
    name: 'end',
    description: (
      <Translator
        file="module-communicationPipeline"
        name="complaint-has-ended"
      />
    ),
  },
];

export const statusProgress = [
  {
    label: (
      <Translator file="module-communicationPipeline" name="to-be-initiated" />
    ),
    value: 'unInitialized',
    color: 'primaryLight',
  },
  {
    label: (
      <Translator file="module-communicationPipeline" name="in-progress" />
    ),
    value: 'inProgress',
    color: 'state2',
  },
  {
    label: <Translator file="module-communicationPipeline" name="completed" />,
    value: 'completed',
    color: 'success',
  },
];

export const statusSign = [
  {
    label: (
      <Translator file="module-communicationPipeline" name="inadmissible" />
    ),
    value: 'denied',
    color: 'danger',
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="redirected-another-area"
      />
    ),
    value: 'redirected',
    color: 'state2',
  },
  {
    label: (
      <Translator
        file="module-communicationPipeline"
        name="requires-information"
      />
    ),
    value: 'informationRequest',
    color: 'bootstrapWarning',
  },
  {
    label: <Translator file="module-communicationPipeline" name="valid" />,
    value: 'approved',
    color: 'success',
  },
];
